<h2 class="LeftPanelTitle">{{ "app.view.editor-filter-view.filter" | translate }}</h2>

<sbb-accordion [multi]="true">
  <sbb-expansion-panel [expanded]="true">
    <sbb-expansion-panel-header>
      <ng-container *ngIf="isTrainrunFilteringActive()">
        {{ "app.view.editor-filter-view.general" | translate }}
      </ng-container>
      <ng-container *ngIf="!isTrainrunFilteringActive()">
        <label style="color: red">{{ "app.view.editor-filter-view.general" | translate }}</label>
      </ng-container>
    </sbb-expansion-panel-header>

    <sbb-label>{{ "app.view.editor-filter-view.category" | translate }}</sbb-label>
    <div class="sbb-trainrun-chip-group">
      <button
        [class]="getCategoryClassname(trainrunCategory)"
        (click)="onCategoryChanged(trainrunCategory)"
        mode="ghost"
        [title]="getCategoryTooltip(trainrunCategory)"
        *ngFor="let trainrunCategory of dataService.getTrainrunCategories()"
      >
        {{ makeCategoryButtonLabel(trainrunCategory) }}
      </button>
    </div>

    <sbb-label class="sbb-mt-m">{{
      "app.view.editor-filter-view.frequency" | translate
    }}</sbb-label>
    <div class="sbb-trainrun-chip-group">
      <button
        [class]="getFrequencyClassname(trainrunFrequency)"
        (click)="onFrequencyChanged(trainrunFrequency)"
        mode="ghost"
        [title]="getFrequencyTooltip(trainrunFrequency)"
        *ngFor="let trainrunFrequency of dataService.getTrainrunFrequencies()"
      >
        {{ makeFrequencyButtonLabel(trainrunFrequency) }}
      </button>
    </div>

    <sbb-label class="sbb-mt-m">{{
      "app.view.editor-filter-view.time-category" | translate
    }}</sbb-label>
    <div class="sbb-trainrun-chip-group">
      <button
        [class]="getTimeCategoryClassname(trainrunTimeCategory)"
        (click)="onTimeCategoryChanged(trainrunTimeCategory)"
        mode="ghost"
        [title]="getTimeCategoryTooltip(trainrunTimeCategory)"
        *ngFor="let trainrunTimeCategory of dataService.getTrainrunTimeCategories()"
      >
        {{ makeTimeCategoryButtonLabel(trainrunTimeCategory) }}
      </button>
    </div>

    <div *ngIf="hasOneWayTrainruns() || isAsymmetryActive()">
      <sbb-label class="sbb-mt-m">{{
        "app.view.editor-filter-view.symmetry" | translate
      }}</sbb-label>
      <div class="sbb-trainrun-chip-group">
        <ng-container *ngIf="hasOneWayTrainruns()">
          <button
            [class]="getDirectionClassname(direction)"
            (click)="onDirectionChanged(direction)"
            mode="ghost"
            [title]="getDirectionTooltip(direction)"
            *ngFor="let direction of dataService.getDirections()"
          >
            {{ makeDirectionButtonLabel(direction) }}
          </button>
        </ng-container>
        <ng-container *ngIf="isAsymmetryActive()">
          <button
            *ngFor="let symmetry of [true, false]"
            [class]="getSymmetryClassname(symmetry)"
            (click)="onSymmetryChanged(symmetry)"
            mode="ghost"
            [title]="getSymmetryTooltip(symmetry)"
          >
            {{ makeSymmetryButtonLabel(symmetry) }}
          </button>
        </ng-container>
      </div>
    </div>

    <button
      sbb-secondary-button
      class="sbb-mt-m"
      [disabled]="isTrainrunFilteringActive()"
      [title]="'app.view.editor-filter-view.display-all-trainruns' | translate"
      (click)="onResetTrainrunFilter()"
    >
      {{ "app.view.editor-filter-view.reset-trainrun-filter" | translate }}
    </button>
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="hasFilteringTrainrunLabels">
    <sbb-expansion-panel-header>
      <ng-container *ngIf="!isFilteringTrainrunLabels()">
        {{ "app.view.editor-filter-view.filterable-labels-trainruns" | translate }}
      </ng-container>
      <ng-container *ngIf="isFilteringTrainrunLabels()">
        <label style="color: red">{{
          "app.view.editor-filter-view.filterable-labels-trainruns" | translate
        }}</label>
      </ng-container>
    </sbb-expansion-panel-header>

    <sbb-filterable-label-filter-view
      [componentLabelRef]="'Trainrun'"
    ></sbb-filterable-label-filter-view>
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="hasFilteringNodeLabels">
    <sbb-expansion-panel-header>
      <ng-container *ngIf="!isFilteringNodeLabels()">
        {{ "app.view.editor-filter-view.filterable-labels-nodes" | translate }}
      </ng-container>
      <ng-container *ngIf="isFilteringNodeLabels()">
        <label style="color: red">{{
          "app.view.editor-filter-view.filterable-labels-nodes" | translate
        }}</label>
      </ng-container>
    </sbb-expansion-panel-header>

    <sbb-filterable-label-filter-view
      [componentLabelRef]="'Node'"
    ></sbb-filterable-label-filter-view>
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="hasFilteringNoteLabels">
    <sbb-expansion-panel-header>
      <ng-container *ngIf="!isFilteringNoteLabels()">
        {{ "app.view.editor-filter-view.filterable-labels-notes" | translate }}
      </ng-container>
      <ng-container *ngIf="isFilteringNoteLabels()">
        <label style="color: red">{{
          "app.view.editor-filter-view.filterable-labels-notes" | translate
        }}</label>
      </ng-container>
    </sbb-expansion-panel-header>

    <sbb-filterable-label-filter-view
      [componentLabelRef]="'Note'"
    ></sbb-filterable-label-filter-view>
  </sbb-expansion-panel>

  <sbb-expansion-panel [expanded]="false">
    <sbb-expansion-panel-header>
      <ng-container *ngIf="isDisplayFilteringActive()">{{
        "app.view.editor-filter-view.display" | translate
      }}</ng-container>
      <ng-container *ngIf="!isDisplayFilteringActive()">
        <label style="color: red">{{ "app.view.editor-filter-view.display" | translate }}</label>
      </ng-container>
    </sbb-expansion-panel-header>

    <sbb-form-field [label]="'app.view.editor-filter-view.decimal-displayed' | translate">
      <input
        sbbInput
        type="number"
        pattern="^[.0-9]*"
        [(ngModel)]="timeDisplayPrecision"
        (change)="onTimeDisplayPrecisionChanged()"
      />
    </sbb-form-field>

    <sbb-label>{{ "app.view.editor-filter-view.Round-trips" | translate }}</sbb-label>
    <div class="sbb-checkbox-group-vertical">
      <sbb-checkbox [(ngModel)]="filterDirectionArrows" (change)="filterDirectionArrowsChanged()"
        >{{ "app.view.editor-filter-view.display-direction-arrows" | translate }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="filterAsymmetryArrows" (change)="filterAsymmetryArrowsChanged()"
        >{{ "app.view.editor-filter-view.display-asymmetry-arrows" | translate }}
      </sbb-checkbox>
      <sbb-checkbox
        [(ngModel)]="filterBackwardTravelTime"
        (change)="filterBackwardTravelTimeChanged()"
        >{{ "app.view.editor-filter-view.display-backward-travel-times" | translate }}
      </sbb-checkbox>
    </div>

    <br />
    <sbb-label>{{ "app.view.editor-filter-view.times" | translate }}</sbb-label>
    <div class="sbb-checkbox-group-vertical">
      <sbb-checkbox
        [(ngModel)]="filterArrivalDepartureTime"
        (change)="filterArrivalDepartureTimeChanged()"
        >{{ "app.view.editor-filter-view.display-arrival-departure-times" | translate }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="filterShowNonStopTime" (change)="filterShowNonStopTimeChanged()">
        {{
          "app.view.editor-filter-view.display-arrival-departure-times-for-connections" | translate
        }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="filterTravelTime" (change)="filterTravelTimeChanged()"
        >{{ "app.view.editor-filter-view.display-travel-times" | translate }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="filterTrainrunName" (change)="filterTrainrunNameChanged()"
        >{{ "app.view.editor-filter-view.display-trainrun-name" | translate }}
      </sbb-checkbox>
    </div>

    <br />
    <sbb-label>{{ "app.view.editor-filter-view.connections" | translate }}</sbb-label>
    <div class="sbb-checkbox-group-vertical">
      <sbb-checkbox [(ngModel)]="filterConnections" (change)="filterConnectionsChanged()"
        >{{ "app.view.editor-filter-view.display-connections" | translate }}
      </sbb-checkbox>
    </div>

    <br />
    <sbb-label>{{ "app.view.editor-filter-view.nodes" | translate }}</sbb-label>
    <div class="sbb-checkbox-group-vertical">
      <sbb-checkbox [(ngModel)]="filterAllEmptyNodes" (change)="filterAllEmptyNodesChanged()"
        >{{ "app.view.editor-filter-view.display-nodes-without-visible-trainruns" | translate }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="filterAllNonStopNodes" (change)="filterAllNonStopNodesChanged()"
        >{{ "app.view.editor-filter-view.display-nodes-with-only-stopping-trainruns" | translate }}
      </sbb-checkbox>
      <sbb-checkbox [(ngModel)]="displayNodesFullName" (change)="displayNodesFullNameChanged()"
        >{{ "app.view.editor-filter-view.display-nodes-full-name" | translate }}
      </sbb-checkbox>
    </div>

    <br />
    <sbb-label>{{ "app.view.editor-filter-view.notes" | translate }}</sbb-label>
    <div class="sbb-checkbox-group-vertical">
      <sbb-checkbox [(ngModel)]="filterNotes" (change)="filterNotesChanged()"
        >{{ "app.view.editor-filter-view.display-notes" | translate }}
      </sbb-checkbox>
    </div>

    <button
      sbb-secondary-button
      class="sbb-mt-m"
      [disabled]="isDisplayFilteringActive()"
      [title]="'app.view.editor-filter-view.reset-display-filter' | translate"
      (click)="onResetDisplayFilter()"
    >
      {{ "app.view.editor-filter-view.reset-display-filter" | translate }}
    </button>
  </sbb-expansion-panel>

  <ng-container *ngIf="versionControlService.getVariantIsWritable()">
    <sbb-expansion-panel [expanded]="false">
      <sbb-expansion-panel-header>
        {{ "app.view.editor-filter-view.saved-filters" | translate }}
      </sbb-expansion-panel-header>
      <div class="sbb-filtersetting-chip-group">
        <ng-container *ngFor="let filterSetting of filterService.getFilterSettings()">
          <ng-container *ngIf="!isActiveEditFilterSetting(filterSetting)">
            <button
              [class]="getFilterSettingClassname(filterSetting)"
              (click)="onFilterSettingChanged(filterSetting)"
              mode="ghost"
              [title]="getFilterSettingTooltip(filterSetting)"
            >
              {{ makeFilterSettingButtonLabel(filterSetting) | translate }}
            </button>

            <button
              [class]="getFilterSettingClassname(filterSetting, true)"
              (click)="onEditFilterSetting(filterSetting)"
              [disabled]="!checkIsFilterSettingActive(filterSetting)"
            >
              <ng-container *ngIf="checkIsFilterSettingActive(filterSetting)">
                <sbb-icon
                  svgIcon="pen-medium"
                  height="13px"
                  width="13px"
                  aria-hidden="false"
                  style="transform: translate(-4px, 2px)"
                >
                </sbb-icon>
              </ng-container>
              <ng-container *ngIf="!checkIsFilterSettingActive(filterSetting)">
                <sbb-icon
                  svgIcon="pen-medium"
                  style="color: lightgray"
                  height="13px"
                  width="13px"
                  aria-hidden="false"
                  style="transform: translate(-4px, 2px)"
                >
                </sbb-icon>
              </ng-container>
            </button>
          </ng-container>

          <ng-container *ngIf="isActiveEditFilterSetting(filterSetting)">
            <input
              tabindex="-1"
              id="ActiveFilterNameElement"
              type="text"
              maxlength="128"
              spellcheck="false"
              [(ngModel)]="activeFilterName"
            />

            <button
              [class]="getFilterSettingClassname(filterSetting, true)"
              (click)="onEditFilterSettingSave(filterSetting)"
            >
              <sbb-icon
                svgIcon="circle-tick-medium"
                height="13px"
                width="13px"
                aria-hidden="false"
                style="transform: translate(-4px, 2px)"
              >
              </sbb-icon>
            </button>
          </ng-container>

          <button
            [class]="getFilterSettingClassname(filterSetting, true)"
            (click)="onDeleteFilterSetting(filterSetting)"
          >
            <sbb-icon
              svgIcon="trash-medium"
              height="13px"
              width="13px"
              aria-hidden="false"
              style="transform: translate(-4px, 2px)"
            >
            </sbb-icon>
          </button>
          <br />
        </ng-container>
        <button
          [class]="getFilterSettingAddButtonClassname()"
          (click)="onSaveAsNewFilterSetting()"
          mode="ghost"
          [title]="'app.view.editor-filter-view.save-filters' | translate"
        >
          <sbb-icon
            svgIcon="circle-plus-medium"
            style="margin-top: 3px; transform: translate(-4px, 2px)"
          ></sbb-icon>
        </button>
      </div>
    </sbb-expansion-panel>
  </ng-container>
</sbb-accordion>

<div style="transform: translate(24px, 10px)">
  <button
    sbb-secondary-button
    class="sbb-mt-m"
    [disabled]="!filterService.isAnyFilterActive()"
    [title]="'app.view.editor-filter-view.reset-all-display-filters' | translate"
    (click)="onResetAllFilter()"
  >
    {{ "app.view.editor-filter-view.reset-all-display-filters" | translate }}
  </button>
</div>
